import { CollisionGroup, CollisionGroupManager } from 'excalibur';

const world = CollisionGroupManager.create('world', CollisionGroup.All.mask);
const santa = CollisionGroupManager.create('santa', CollisionGroup.collidesWith([world]).mask);
const elf = CollisionGroupManager.create('elf', CollisionGroup.collidesWith([world]).mask);

export const COLLISION_GROUPS = { world, santa, elf };
